import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";
import Exporting from "highcharts/modules/exporting.js";
import ExportData from "highcharts/modules/export-data.js";
import { BootstrapInput } from "app/components/common/BootStrapInput";

import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import LineChart from "app/components/charts/LineChart";
import "./CompletionOverTimeLineChart.css";

HighchartsMore(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);

const getSeriesData = (completionData) => {

    let seriesData = [];

    const colorMap = {
        "Certificates": "#6AA4DC",
        "Associates degree": "#9EE4F2",
        "Bachelors degree": "#FFB607",
        "Masters degree": "#FFAAA0",
        "Doctors degree": "#DE3E40",
    };

    Object.keys(colorMap).forEach(degree => {
        let series = {
            name: degree,
            data: [],
            color: colorMap[degree],
            zones: [],
            zoneAxis: 'x',
        };

        if (degree in completionData) {
            completionData[degree].forEach((point, index) => {
                series.data.push({ x: point.year, y: point.counts, ...point });

                if (index < completionData[degree].length - 1) {
                    let nextPoint = completionData[degree][index + 1];
                    if (nextPoint.actual !== point.actual) {
                        series.zones.push({
                            value: nextPoint.year,
                            dashStyle: point.actual === 1 ? 'Solid' : 'Dash'
                        });
                    }
                }
            });

            let lastPoint = completionData[degree][completionData[degree].length - 1];
            series.zones.push({
                dashStyle: lastPoint.actual === 1 ? 'Solid' : 'Dash'
            });

            seriesData.push(series);
        }
    });

    return seriesData;
};

class CompletionOverTimeLineChart extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        let seriesData = getSeriesData(this.props.completionData);

        return (
            <>
                <div class="legend">
                    <div class="legend-item">
                        <span class="legend-square legend-certificates"></span>
                        <span>Certificates</span>
                    </div>
                    <div class="legend-item">
                        <span class="legend-square legend-associates"></span>
                        <span>Associates</span>
                    </div>
                    <div class="legend-item">
                        <span class="legend-square legend-bachelors"></span>
                        <span>Bachelors</span>
                    </div>
                    <div class="legend-item">
                        <span class="legend-square legend-masters"></span>
                        <span>Masters</span>
                    </div>
                    <div class="legend-item">
                        <span class="legend-square legend-doctorates"></span>
                        <span>Doctorates</span>
                    </div>
                </div>

                <LineChart
                    remainingOptions={{
                        chart: {
                            animation: false,
                            backgroundColor: "transparent",
                            height: 630,
                            width: 800,
                            spacingTop: 20,
                        },

                        tooltip: {
                            style: {
                                font: "Arial",
                                fontSize: "14px",
                                color: "#333333",
                                zIndex: 999
                            },
                            useHTML: true,
                            followPointer: true,
                            borderRadius: 15,
                            borderWidth: 1,
                            borderColor: "#707070",
                            backgroundColor: "#FFFFFF",
                            padding: 17,
                            shape: "square",
                            formatter: function () {
                                return (
                                    '<b>' + this.series.name + '</b><br style="line-height: 250%;">' +
                                    '% AZ Freshmen: <b>' + ((this.point.actual === 0 && this.point.az_freshmen_percent === null) ? '' : Highcharts.numberFormat(this.point.az_freshmen_percent, 2)) + '</b><br style="line-height: 250%;">' +
                                    'AZ Freshmen in US: <b>' + ((this.point.actual === 0 && this.point.az_freshmen_in_us === null) ? '' : Highcharts.numberFormat(this.point.az_freshmen_in_us, 0, '.', ',')) + '</b><br style="line-height: 250%;">' +
                                    'AZ Freshmen: <b>' + ((this.point.actual === 0 && this.point.az_freshmen === null) ? '' : Highcharts.numberFormat(this.point.az_freshmen, 0, '.', ',')) + '</b><br style="line-height: 250%;">' +
                                    this.x + ' Completions: <b>' + Highcharts.numberFormat(this.y, 0, '.', ',') + '</b>'
                                );
                            },
                        },

                        title: {
                            text: "",
                            style: {
                                color: "#FFF",
                                font: "normal normal bold 24px/28px Arial",
                            },
                            align: "left",
                            x: 90,
                        },

                        xAxis: {
                            gridLineWidth: 0,
                            tickInterval: 2,
                            title: {
                                text: "Year",
                                style: {
                                    color: "#fff",
                                    font: "normal normal normal 18px Arial",
                                },
                            },
                            labels: {
                                formatter: function () {
                                    return "'" + String(this.value).slice(-2);
                                },
                                style: {
                                    color: "#fff",
                                    font: "normal normal normal 18px Arial",
                                },
                                y: 35,
                            },
                        },

                        yAxis: {
                            gridLineWidth: 0.5,
                            title: {
                                text: "Number of Completions",
                                style: {
                                    color: "#fff",
                                    font: "normal normal normal 18px Arial",
                                },
                            },
                            labels: {
                                formatter: function () {
                                    return (this.value / 1000).toString() + "K";
                                },
                                style: {
                                    color: "#fff",
                                    font: "normal normal normal 18px Arial",
                                },
                            },
                            maxPadding: 0.2,
                        },
                        plotOptions: {
                            series: {
                                animation: false,
                                label: {
                                    connectorAllowed: false,
                                },
                                pointStart: 2005,
                                marker: {
                                    enabled: true,
                                    radius: 2,
                                    symbol: 'square'
                                }
                            },
                        },
                        series: seriesData,
                        legend: {
                            enabled: false
                        },
                    }}
                />
            </>
        );
    }
}

export default CompletionOverTimeLineChart;
